import React from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';

const BuyerLoginPage = () => {
  const [inParams] = useSearchParams();
  const destination = inParams.get('destination');
  const outParams = new URLSearchParams();

  if (destination) {
    outParams.set('destination', destination);
  }

  const finalParams = outParams.toString() ? `?${outParams.toString()}` : '';

  return <Navigate to={`/login${finalParams}`} replace />;
};

export default BuyerLoginPage;
